import React, { Component } from 'react';
import { FIELDS_CHECK_FORM, FIELDS_FORM } from './fields';
import Alert from '../../alert';
import Loader from '../../loader/form';
import BtnLoader from '../../loader/button';
import styles from 'bundle-text:./styles.css';
import iconWarning from 'url:../../../img/warning.png';
import 'regenerator-runtime/runtime';

const MESSAGES_ERROR = [
  'Required fields.',
  'An error occurred, try again.',
  'Could not send information, please check your internet connection and try again.',
];

const NAME_FORM = 'CONTACTUSA';

const DEFAULT_VALUES_FORM = FIELDS_FORM;

class FormContact extends Component {
  constructor() {
    super();
    this.state = {
      fields: FIELDS_FORM,
      indexError: 0,
      social: '',
      otherText: '',
      isLoading: false,
      isAllEmpty: false,
      isOpenAlert: false,
      isErrorMessage: false,
      isEmptyAboutUs: false,
    };
  }

  handleChange = (event) => {
    event.preventDefault();
    const {
      target: { name, value },
    } = event;
    const fields = this.state.fields;
    fields[name].value = value;
    fields[name].isError = false;

    this.setState({
      fields,
      isAllEmpty: false,
      isErrorMessage: false,
    });
  };

  handleChangeChecks = (event) => {
    const {
      target: { name },
    } = event;
    if(this.state.social !== name){
      this.setState({
        social: name,
        otherText: ''
      });
    }
    this.setState({
      isAllEmpty: false,
      isEmptyAboutUs: false
    });
  }

  handleChangeOtherText = (event) => {
    event.preventDefault();
    const {
      target: { value },
    } = event;
    this.setState({
      otherText: value
    });
  }

  handleAccept = (event) => {
    event.preventDefault();
    ga('send', 'event', 'Form contact', 'Click', 'Form finished');

    this.setState({ isOpenAlert: false });
  };

  validFieldsForm = async (event) => {
    ga('send', 'event', 'Form contact', 'Click', 'Submit');
    event.preventDefault();

    const { fields, social, otherText } = this.state;
    const {
      contactName,
      contactLastName,
      contactEmail,
      contactPhone,
      contactCompany,
      contactCity,
      contactState
    } = fields;

    const isAllEmpty = Object.values(fields).every((data) => !data.value);

    if (isAllEmpty) {
      this.setState({
        indexError: 0,
        isAllEmpty: true,
        isErrorMessage: true,
      });
      return;
    }
    
    if (!contactName.value) {
      fields.contactName.isError = true;
      this.setState({ fields });
      return;
    }

    if (!contactLastName.value) {
      fields.contactLastName.isError = true;
      this.setState({ fields });
      return;
    }

    const checkValidEmail =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!checkValidEmail.test(contactEmail.value)) {
      fields.contactEmail.isError = true;
      this.setState({ fields });
      return;
    }

    if (contactPhone.value) {
      const checkValidPhone =
        /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
      if (!checkValidPhone.test(contactPhone.value)) {
        fields.contactPhone.isError = true;
        this.setState({ fields });
        return;
      }
    }
    
    if (!contactCompany.value) {
      fields.contactCompany.isError = true;
      this.setState({ fields });
      return;
    }

    if (!contactCity.value) {
      fields.contactCity.isError = true;
      this.setState({ fields });
      return;
    }

    if (!contactState.value) {
      fields.contactState.isError = true;
      this.setState({ fields });
      return;
    }

    if (!social || social === 'other' && !otherText.length) {
      this.setState({ isEmptyAboutUs: true });
      return;
    }

    await this.sendInformationForm({...fields, social, otherText});
  };

  async sendInformationForm({
    contactEmail,
    contactName,
    contactLastName,
    contactCompany,
    contactPhone,
    contactCity,
    contactState,
    social,
    otherText
  }) {
    const aboutUs = social === 'other' && otherText.length ? otherText : social;

    const contact = {
      form: NAME_FORM,
      name: contactName.value,
      lastName: contactLastName.value,
      email: contactEmail.value,
      phone: contactPhone.value,
      company: contactCompany.value,
      city: contactCity.value,
      state: contactState.value,
      aboutUs
    };
    
    // TODO: ADD ENV
    const api = 'https://c8btjlx1sg.execute-api.us-east-2.amazonaws.com/prod/contact-form';
    const apiKey = { 'x-api-key': 'uks3cgatl0cz2a5sosfbbrpi7ai4jk03' };

    const request = {
      method: 'POST',
      headers: { ...apiKey },
      body: JSON.stringify(contact),
    };

    this.setState({ isLoading: true });

    ga('send', 'event', 'Form contact', 'Send', 'Request demo');
    setTimeout(async () => {
      try {
        const response = await fetch(api, request);
        switch (response.status) {
          case 200:
            this.setState({
              fields: DEFAULT_VALUES_FORM,
              social: '',
              otherText:  '',
              isOpenAlert: true,
            });
            break;
          case 400:
            this.setState({
              indexError: 0,
              isErrorMessage: true,
            });
            break;
          case 405:
            this.setState({
              indexError: 1,
              isErrorMessage: true,
            });
            break;
          case 500:
            this.setState({
              indexError: 1,
              isErrorMessage: true,
            });
            break;
          default:
            this.setState({
              indexError: 1,
              isErrorMessage: true,
            });
            break;
        }
      } catch (e) {
        console.error('Not send info', e);
        this.setState({
          indexError: 2,
          isErrorMessage: true,
        });
      }

      this.setState({ isLoading: false });
    }, 500);
  }

  render() {
    const {
      fields,
      social,
      otherText,
      isLoading,
      indexError,
      isAllEmpty,
      isOpenAlert,
      isErrorMessage,
      isEmptyAboutUs,
    } = this.state;

    return (
      <React.Fragment>
        <Alert isOpen={isOpenAlert} onAccept={this.handleAccept} />
        <style>{styles}</style>
        <form className="card__form">
          <Loader active={isLoading} />
          <div className="header">
            <h5 className="title">
              The most efficient <br />
              <strong>earthquake early warning</strong>
              <br /> system for businesses
            </h5>
            <div className="divider__line"></div>
          </div>
          <div className="body">
            {Object.values(fields).map((element, index) => (
              <div
                key={index}
                className={`container__fields ${
                  isAllEmpty && element.isRequired ? 'empty' : ''
                }`}
              >
                <input
                  id={element.name}
                  name={element.name}
                  className={`fields ${element.isError ? 'empty' : ''}`}
                  type={element.type}
                  placeholder={element.placeholder}
                  onChange={this.handleChange}
                  disabled={isLoading}
                  value={element.value}
                  maxLength={element.maxlength}
                />
                {
                  <label htmlFor={element.name} className="error">
                    {element.isError && element.message}
                  </label>
                }
              </div>
            ))}
            <div className='container__fields check'>
            <p className={`subtitle ${isEmptyAboutUs ? 'empty' : ''}`}>
              *How did you hear about us?
            </p>
            {
              Object.values(FIELDS_CHECK_FORM).map((field)=> (
                <label className="form__checkbox" key={field.name}>
                  {field.text}
                  <input 
                    className='checkmark'
                    type={field.type} 
                    name={field.name} 
                    value={field.value} 
                    disabled={isLoading}
                    checked={field.name === social}
                    onChange={this.handleChangeChecks} 
                  />
                {
                  social === 'other' && field.name === 'other' &&
                  <input 
                    id="other__text" 
                    type="text" 
                    name="other__text" 
                    className={`fields ${!otherText && isEmptyAboutUs ? 'empty' : ''} `}
                    disabled={isLoading}
                    onChange={this.handleChangeOtherText}
                  />
                }
                </label>
              ))
            }
              <label className="error text__other">
              {isEmptyAboutUs && !isAllEmpty &&
                'Please enter a option.'
              }
              </label>
            </div>
            <p className='required'>*Required field.</p>
            {isErrorMessage && 
            <div className={`message ${isErrorMessage ? 'error' : ''}`}>
              <p className="text__message">
                <img className="icon" src={iconWarning} alt="Warning" />
                {MESSAGES_ERROR[indexError]}
              </p>
            </div>}
          </div>
          <div className="footer">
            <button
              className={`btn btn__request ${isLoading ? 'disabled' : ''}`}
              onClick={this.validFieldsForm}
              disabled={isLoading}
              type="submit"
            >
              <BtnLoader active={isLoading} />
              Request Demo
            </button>
          </div>
        </form>
      </React.Fragment>
    );
  }
}

export default FormContact;
